import script from "./KanbanView.vue?vue&type=script&setup=true&lang=ts"
export * from "./KanbanView.vue?vue&type=script&setup=true&lang=ts"

import "./KanbanView.vue?vue&type=style&index=0&id=3648b926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3648b926"]])

export default __exports__